import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiErr } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Skeleton } from "@/components/ui/skeleton";
import { toast } from "sonner";
import { Radio, Send, Loader2 } from "lucide-react";

export default function Broadcasts() {
  const [bots, setBots] = useState(null);
  const [botId, setBotId] = useState("");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  useEffect(() => { api.get("/bots", { params: { status: "active", page_size: 100 } }).then((r) => setBots(r.data.items)).catch(() => setBots([])); }, []);
  const send = async () => {
    setBusy(true);
    try { const { data } = await api.post("/broadcasts", { bot_id: botId, text }); toast.success(`Broadcast queued to ${data.recipients} chats`, { description: "Track in Jobs." }); navigate("/jobs"); }
    catch (e) { toast.error(apiErr(e)); }
    setBusy(false);
  };
  return (
    <div className="space-y-5">
      <PageHeader title="Messages & Broadcasts" desc="Send a message to every chat a bot has interacted with." testId="broadcasts-header" />
      {!bots ? <Skeleton className="h-52 w-full" /> : bots.length === 0 ? (
        <div className="bg-card border border-border rounded-lg"><EmptyState icon={Radio} title="No active bots" desc="Add an active bot to broadcast messages." testId="empty-broadcast" /></div>
      ) : (
        <div className="bg-card border border-border rounded-lg p-6 space-y-4 max-w-xl">
          <div><Label>Bot</Label>
            <Select value={botId} onValueChange={setBotId}><SelectTrigger data-testid="select-broadcast-bot"><SelectValue placeholder="Choose a bot" /></SelectTrigger>
              <SelectContent>{bots.map((b) => <SelectItem key={b.id} value={b.id}>{b.name} (@{b.username})</SelectItem>)}</SelectContent></Select>
          </div>
          <div><Label>Message</Label><Textarea data-testid="input-broadcast-text" rows={5} value={text} onChange={(e) => setText(e.target.value)} placeholder="Your broadcast message…" /></div>
          <Button onClick={send} disabled={busy || !botId || !text} data-testid="btn-send-broadcast" className="gap-1.5">{busy ? <Loader2 size={15} className="animate-spin" /> : <Send size={15} />} Queue broadcast</Button>
          <p className="text-xs text-muted-foreground">Runs as a background job with per-message rate-limit handling.</p>
        </div>
      )}
    </div>
  );
}
